export const normalizePath = (path: string): string => {
  if (!path) return "";
  let cleaned = path.replace(/^\/+/, "");
  cleaned = cleaned.replace(/\/+$/, "");
  cleaned = cleaned.replace(/([^:])\/{2,}/g, "$1/");
  return cleaned;
};

export const prependPublic = (path: string): string => {
  const cleaned = normalizePath(path);
  return `public/${cleaned}`;
};

export const safeJoinUrl = (base: string, path: string): string => {
  const cleanBase = base.replace(/\/+$/, "");      
  const cleanPath = normalizePath(path);          
  return `${cleanBase}/${cleanPath}`;
};
